var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemWorkspace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.006 2A2.996 2.996 0 0 1 22 4.994v14.012A2.996 2.996 0 0 1 19.006 22H4.994A2.996 2.996 0 0 1 2 19.006V4.994A2.996 2.996 0 0 1 4.994 2zm.33 1.674H4.692a.996.996 0 0 0-.994.994v14.69c0 .548.446.994.994.994h14.642a.996.996 0 0 0 .994-.994V4.668a.996.996 0 0 0-.994-.994M16.004 7c.55 0 .995.456.995.995v8.01c0 .55-.456.995-.995.995h-8.01c-.55 0-.995-.456-.995-.995v-8.01c0-.55.456-.995.995-.995z"
})));
export default SvgGemWorkspace;